import type { RevenueReport } from '@witmetrics/utils';
import { usePracticeCurrency } from '@witmetrics/data-store';
import Chart from '@/charts/Chart';
import { formatReport } from './utils';

export type RevenueGrowthChartProps = {
  currentReport: RevenueReport;
  previousReport: RevenueReport;
  onMount?: () => void;
};

export default function RevenueGrowthChart({
  currentReport,
  previousReport,
  onMount,
}: RevenueGrowthChartProps) {
  const currency = usePracticeCurrency();
  const reportData = formatReport(currentReport, previousReport, currency);
  return (
    <Chart
      type="line"
      width="100%"
      height="100%"
      options={reportData.options}
      series={reportData.series}
      onMount={onMount}
    />
  );
}
